<template>
    <div class="w-12 2xl:w-44">
        <div v-if="selectedOrg" class="hidden 2xl:flex mr-4">
            <button
                v-for="i in panelNumber"
                :key="i"
                class="menu-item h-[52px]"
                :class="{'panel-active': panelCount === i}"
                @click="setPanelCount(i)"
            >
                <img
                    :src="panelIconPath(i)"
                    alt="Panel button"
                >
            </button>
        </div>
        <dropdown-menu
            v-if="selectedOrg"
            class="2xl:hidden"
            :top-bar="true"
            :panel-chooser="true"
            direction="left"
        >
            <template #button>
                <button class="menu-item panel-active h-[52px]" title="Velg antall paneler">
                    <img :src="panelIconPath(panelCount)" alt="Panel chooser dropdown">
                </button>
            </template>
            <template #dropdown="{close}">
                <div class="flex w-40" @click="close">
                    <button
                        v-for="i in panelNumber"
                        :key="i"
                        class="pb-1 pt-2"
                        :title="`Vis ${i} panel`"
                        :class="{'panel-active': panelCount === i}"
                        @click="setPanelCount(i)"
                    >
                        <img :src="panelIconPath(i)" alt="Panel button">
                    </button>
                </div>
            </template>
        </dropdown-menu>
    </div>
</template>

<script setup lang="ts">

import {selectedOrg} from '@/tenants/org.service'
import {usePanelManager} from '@tritt/multipanel'
import {isDark} from '@/theme/theme.service'
import DropdownMenu from '@/components/DropdownMenu.vue'
import {computed} from 'vue'

const pm = usePanelManager()
const panelCount = computed({
    get: () => pm.panelCount.value,
    set: (v: number) => { pm.panelCount.value = v }
})
const panelNumber = [1, 2, 3, 4]

const panelIconPath = (panel: number) => {
    if (isDark.value) {
        return `/${panel}panel.svg`
    }
    return `/${panel}panel-dark.svg`
}

const setPanelCount = (count: number) => {
    panelCount.value = count
}
</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.menu-item {
    @apply items-center mx-0.5 text-xs py-1;

    i {
        @apply text-lg mr-1 text-primary;
    }
}

.item {
    @apply flex flex-col;
}

.panel-active {
    @apply bg-base-200;
}
</style>